module.exports = __webpack_public_path__ + "img/dongji_ps_06.ffedaefa.jpg";